/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfPostizIntegration } from "../models/AjaxResponseOfPostizIntegration";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class PublicAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfPostizIntegration Success
   * @throws ApiError
   */
  public getUserInstagramInformation({
    teamId,
  }: {
    teamId: string;
  }): CancelablePromise<AjaxResponseOfPostizIntegration> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/public/instagram-user-information/{teamId}",
      path: {
        teamId: teamId,
      },
    });
  }
}
